// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusContainer_root__2yTIU"};